import React, { useEffect } from "react";

import gsap from "gsap";

import "./index.scss";

import mockup from "mockup";
import Card from "components/Card";
import BackCloseButton from "components/BackCloseButton";
import DrinkResponsibly from "../../components/DrinkResponsibly";

import { useNavigation } from "hooks/useNavigation";

import "swiper/scss";
import { Swiper, SwiperSlide } from "swiper/react";

import background from "assets/background/background-cocktail-hub.webp";
import { Cocktail } from "../../models/Cocktail";

const Menu = () => {
  const navigate = useNavigation();

  const fadeInTime = 0.2;

  useEffect(() => {
    gsap
      .timeline()
      .to([".menu-title-container, .card"], {
        opacity: 0,
        duration: 0,
      })
      .to(
        [".menu-title-container"],
        {
          opacity: 1,
        },
        fadeInTime
      )
      .to(
        [".card"],
        {
          opacity: 1,
          stagger: 0.1,
        },
        fadeInTime
      );
  }, []);

  return (
    <div
      className="menu page"
      style={{
        backgroundImage: `url(${background})`,
      }}
    >
      <BackCloseButton navigationPath="/home" />

      <div className="menu-content">
        <div className="menu-title-container">
          <h1 className="menu-title heading-huge">
            CAMPARI’S ICONIC COCKTAILS
          </h1>
          <h2 className="menu-subtitle heading-2">
            Inspiring timeless creations since 1860
          </h2>
        </div>

        <Swiper
          spaceBetween={-800}
          slidesPerView={3}
          centeredSlides={true}
          initialSlide={3}
          onSlideChange={({ activeIndex }) =>
            ((
              document.querySelector(".swiper-wrapper") as HTMLElement
            ).style.right = !activeIndex ? "0" : "450px")
          }
        >
          {mockup
            .sort((a, b) => +a.id - +b.id)
            .map(({ id, img, title, subtitle }: Cocktail) => (
              <SwiperSlide>
                {(slider) => (
                  <Card
                    img={require(`assets/img/${img}`)}
                    title={title}
                    subtitle={subtitle}
                    onClickAction={() => navigate(`/detail/${id}`)}
                  />
                )}
              </SwiperSlide>
            ))}
        </Swiper>
      </div>

      <DrinkResponsibly />
    </div>
  );
};

export default Menu;
